<template>
    <v-app>
        <v-content>
           <v-container
            class="fill-height"
            fluid
           >
              <v-row 
                align='center'
                justify='center'
                >
                <v-img
                    :src="require('@/assets/loader.gif')"
                    aspect-ratio="1"
                    max-width="400"
                    max-height="200"
                    contain
                ></v-img>
               
            </v-row>
           </v-container>
        </v-content>
    </v-app>
</template>
<script>
export default {
    data () {
      return {
        interval: {},
        value: 0,
      }
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted () {
      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 100)
        }
        this.value += 10
      }, 5)
    },
  }
</script>